var cardPointElement = document.querySelector('.card-contact');

function getPoints() {
  var json = document.querySelector('.map').getAttribute('data-points');
  return JSON.parse(json);
}

function displayPointCard({phone, title}) {
  var titleElement = cardPointElement.querySelector('.card-contact-title');
  var phoneElement = cardPointElement.querySelector('.card-contact-phone a');

  cardPointElement.classList.add('is-show');

  titleElement.innerText = title;
  phoneElement.innerText = phone;
  phoneElement.setAttribute('href', 'tel:' + phone);
}

function initMap () {
  var map = new ymaps.Map('map', {
    center: [55.836877, 37.916126],
    zoom: 8,
    controls: []
  }),

  clusterer = new ymaps.Clusterer({
    preset: 'islands#invertedRedClusterIcons',
    groupByCoordinates: false,
    clusterDisableClickZoom: false,
    clusterHideIconOnBalloonOpen: false,
    hasBalloon: false
  }),

  getPointOptions = function () {
    return {
      iconLayout: 'default#image',
      iconImageHref: 'img/placemark.svg',
      hasBalloon: false
    };
  },

  points = getPoints(),
  geoObjects = [];

  for (var i = 0, len = points.length; i < len; i++) {
    geoObjects[i] = new ymaps.Placemark(points[i].coord, points[i].data, getPointOptions());

    geoObjects[i].events.add('click', function(e) {
      var point = e.get('target');
      var phone = point.properties.get('phone');
      var title = point.properties.get('title');

      displayPointCard({phone, title});

      // смена цвета
      for (var j = 0; j < geoObjects.length; j++) {
        geoObjects[j].options.set('iconImageHref', 'img/placemark.svg');
      }

      point.options.set('iconImageHref', 'img/placemark-active.svg');
    });
  }

  clusterer.options.set({
    gridSize: 32,
    clusterDisableClickZoom: true
  });

  clusterer.add(geoObjects);
  map.geoObjects.add(clusterer);

  map.setBounds(clusterer.getBounds(), {
    checkZoomRange: true
  });
}

module.exports = initMap
